import { useTranslation } from '@common/hooks/translation';
import React from 'react';

const VerificationSuccess = ({ closePopup }) => {
  const t = useTranslation();

  return (
    <div className="popup-content popup-small">
      <h3 className="popup-title">{t('Verification')}</h3>
      <div className="popup-main-content">
        <i className="popup-main-icon global-icon icon-success-empty" />
        <p className="text-center">{t('Your verification is completed')}</p>
      </div>
      <button onClick={closePopup} className="popup-confirm-button">
        {t('OK')}
      </button>
    </div>
  );
};

export default VerificationSuccess;
